
import moment from "moment/moment";
import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export class CommonUtils {
  static getLastDayOfQuarterMonth(date: any) {
    let retVal = moment(date, "MM-DD-YYYY").endOf('quarter').toDate();
    return retVal;
  }

  static generateYearQuartersByYear(selectedYear: any) {
    moment.locale('en');
    const currentDate = moment(); // Current date
    const currentYear = currentDate.year(); // Get the current year
    const currentQuarter = Math.ceil((currentDate.month() + 1) / 3); // Determine the current quarter (1-4)

    // Array to hold the quarters
    let quarters = [{
      value: -1,
      name: 'All Quarters'
    }];

      if (selectedYear < currentYear) {
        // If selected year is past, generate all quarters for that year
        for (let i = 1; i <= 4; i++) {
          const startMonth = moment().year(selectedYear).quarter(i).startOf('quarter');
          const endMonth = moment().year(selectedYear).quarter(i).endOf('quarter');
          quarters.push({
            value: i,
            name: `Quarter ${i} (${startMonth.format("MMMM")}-${endMonth.format("MMMM")})`
          });
        }
      } else if (selectedYear === currentYear) {
        // If the selected year is the current year, generate quarters up to the current quarter
        for (let i = 1; i <= currentQuarter; i++) {
          const startMonth = moment().year(selectedYear).quarter(i).startOf('quarter');
          const endMonth = moment().year(selectedYear).quarter(i).endOf('quarter');
          quarters.push({
            value: i,
            name: `Quarter ${i} (${startMonth.format("MMMM")}-${endMonth.format("MMMM")})`
          });
        }
      }

      return quarters;
  }

  static generateListofQtr(reportingYear: any) {
    let printQtrList = [];
    let qtrList: any = [{
      "value": -1,
      "name": "All Quarters"
    },{
      "value": 1,
      "name": "Quarter 1 (January - March)"
    },
      {
        "value": 2,
        "name": "Quarter 2 (April - June)"
      },
      {
        "value": 3,
        "name": "Quarter 3 (July - September)"
      },
      {
        "value": 4,
        "name": "Quarter 4 (October - December)"
      }];
    const curYear = new Date().getFullYear();
    const inputYear = Number(reportingYear);
    if (curYear === inputYear) {
      const currQtr = moment().quarter();
      var currDate = new Date();

      if (currQtr === 1) { qtrList = null; }
      if (currQtr === 2) {
        const lastQtrDate = CommonUtils.getLastDayOfQuarterMonth('01-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          printQtrList = qtrList.filter(qtr => qtr.value === 1);
        }
      }
      if (currQtr === 3) {
        const lastQtrDate = CommonUtils.getLastDayOfQuarterMonth('06-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          printQtrList = qtrList.filter(qtr => qtr.value < 3);
        } else
          printQtrList = qtrList.filter(qtr => qtr.value === 1);
      }

      if (currQtr === 4) {
        const lastQtrDate = CommonUtils.getLastDayOfQuarterMonth('09-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          printQtrList = qtrList.filter(qtr => qtr.value < 4);
        } else
          printQtrList = qtrList.filter(qtr => qtr.value < 3);
      }
    } else {
      if (curYear === inputYear - 1) {
        const currQtr = moment().quarter();
        if (currQtr === 1) {
          const currDate = new Date();
          const lastQtrDate = CommonUtils.getLastDayOfQuarterMonth('09-01-' + inputYear);
          if (moment(lastQtrDate).diff(moment(currDate), 'days') < 60) {
            printQtrList = qtrList.filter(qtr => qtr.value < 4);
          }else
            printQtrList = qtrList;
        }
      }else
        printQtrList = qtrList;
    }
    return printQtrList;
  }

  static greaterThanZeroValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value <= 0) {
        return { 'greaterThanZero': true };
      }
      return null;
    };
  }

  static isDecimalValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value && !isNaN(value)) {
        const stringValue = value.toString();
        if (stringValue.includes('.')) {
          const decimalIndex = stringValue.indexOf('.');
          const decimals = stringValue.slice(decimalIndex + 1);
          if (decimals.length === 2) {
            return null;
          }
        }
      }
      return { 'notDecimal': true };
    };
  }
}
